<div mat-dialog-content>
  <p>{{data.title}}</p>
  <mat-form-field>
    <input matInput [(ngModel)]="data.inputData">
  </mat-form-field>
</div>
<div mat-dialog-actions>
 
  <button mat-raised-button color="primary" [mat-dialog-close]="data.inputData" cdkFocusInitial>Ok</button>
  <button mat-button color="warn" (click)="onNoClick()">{{'cancel' | translation}}</button>
</div>
